import AnalysisTableRequest from 'Modules/contacard/analysisTable/AnalysisTableRequest';
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import UsersRequest from '@/app/users/UsersRequest';
import ClientAccessEnum from '@/app/arch/enums/ClientAccessEnum';
import ClientRegisterEnum from '@/app/arch/enums/ClientRegisterEnum';

export default {
  components: { ModalsRequest, FormGroup },
  mixins: [RulesMixin, ServiceMixin],
  data: () => ({
    requestClass: AnalysisTableRequest,
    observationSwal: {
      errorMessage: 'Falha ao criar observação para um cliente!',
      showSuccessSwal: false,
    },
    userLogoutFaultMessage: {
      successMessage: 'Sucesso ao deslogar cliente!',
      errorMessage: 'Falha ao deslogar cliente!',
    },
    userRequest: UsersRequest,
  }),
  computed: {
    getClientId() {
      return this.analysisTable.client.id;
    },
    hasId() {
      return Number(this.getClientId) >= 1;
    },
    proxyRequest() {
      return (method) => () => this.requestClass[method](this.preparePayload)
        .then(this.makeObservationRequest);
    },
    preparePayload() {
      return {
        ...this.payload,
        clienteId: this.getClientId,
      };
    },
    prepareObservationRequest() {
      const { motivoSituacaoCadastral, motivoSituacaoAcesso } = this.payload;
      return () => this.requestClass.createObs({
        linked: 'Client',
        message: motivoSituacaoAcesso || motivoSituacaoCadastral,
        registerClientId: this.registerClientId,
        type: 'System',
      });
    },
    registerClientId() {
      return this.analysisTable.payload.registerClientId;
    },
    getUserSystemId() {
      return this.analysisTable.client.idUsuarioAdmin;
    },
  },
  methods: {
    success(ev) {
      this.$emit('success', ev);
    },
    makeObservationRequest(res) {
      this.callService(this.prepareObservationRequest(), this.observationSwal);
      this.logoutUser(res);
      return res;
    },
    logoutUser() {
      if (this.payload.situacaoAcesso) {
        this.logoutUserByAccessActions(this.payload.situacaoAcesso);
      } else if (this.payload.situacaoCadastral) {
        this.logoutUserByRegisterActions(this.payload.situacaoCadastral);
      }
    },
    logoutUserByAccessActions(situacaoAcesso) {
      const invalidAccess = ClientAccessEnum.map(
        (status) => status.value,
      ).filter(
        (status) => status !== 'NORMAL',
      );
      if (invalidAccess.includes(situacaoAcesso)) {
        this.makeLogoutUserRequest();
      }
    },
    logoutUserByRegisterActions(situacaoCadastral) {
      const invalidAccess = ClientRegisterEnum.map(
        (status) => status.value,
      ).filter(
        (status) => status === 'RECUSADO',
      );
      if (invalidAccess.includes(situacaoCadastral)) {
        this.makeLogoutUserRequest();
      }
    },
    makeLogoutUserRequest() {
      this.callService(
        this.userRequest.logout(
          this.getUserSystemId,
        ),
        this.userLogoutFaultMessage,
      );
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          client: {
            id: '',
            idUsuarioAdmin: '',
          },
          payload: {
            registerClientId: '',
          },
        };
      },
    },
  },
};
